import * as models from '../../../models';
import * as moment from 'moment';

export class EmailMapper {
  private static instance: EmailMapper = new EmailMapper();

  static Instance(): EmailMapper {
    return EmailMapper.instance;
  }

  emailDtoToEmail(item): models.Email {
    const email = new models.Email();
    email.id = item.id;
    email.from = item.from;
    email.to = item.to;
    email.cc = item.cc;
    email.bcc = item.bcc;
    email.originalFrom = item.originalFrom;
    email.originalTo = item.originalTo;
    email.originalCc = item.originalCc;
    email.originalBcc = item.originalBcc;
    email.repliesTo = item.repliesTo;
    email.subject = item.subject;
    email.template = item.template;
    email.skipSending = item.skipSending;
    if (item.sent) {
      email.sent = moment.utc(item.sent).toDate();
    }
    email.body = item.body;
    if (item.emailAttachments && item.emailAttachments.length) {
      email.emailAttachments = item.emailAttachments.map((attachment) => attachment.name);
    }
    if (item.emailNotificationHistories) {
      email.emailNotificationHistories = item.emailNotificationHistories.map((historyItem) => {
        return this.emailHistoryDtoToEmailHistory(historyItem);
      });
    }
    if (item.document) {
      email.document = item.document.map((document) => {
        return this.emailDocument(document);
      });
    }
    return email;
  }

  emailDocument(item: any): models.EmailNotificationDocument {
    return new models.EmailNotificationDocument()
      .setCollection(item.collection)
      .setDocumentId(item.documentId);
  }

  emailHistoryDtoToEmailHistory(item: any): models.EmailNotificationHistory {
    const history = new models.EmailNotificationHistory()
      .setComment(item.comment)
      .setEventType(item.eventType)
      .setTimestamp(moment(item.timestamp).toDate())
      .setRecipients(item.recipients)
      .setUserAgent(item.userAgent)
      .setIpAddress(item.ipAddress);

    if (item.bouncedRecipients) {
      history.setBouncedRecipients(
        item.bouncedRecipients.map((recipient) =>
          this.bouncedRecipientDtoToBouncedRecipient(recipient)
        )
      );
    }

    return history;
  }

  bouncedRecipientDtoToBouncedRecipient(item: any): models.EmailBouncedRecipient {
    const recipient = new models.EmailBouncedRecipient()
      .setAction(item.action)
      .setDiagnosticCode(item.diagnosticCode);

    return recipient;
  }
}
